import { useCallback } from 'react';

import { AxiosError } from 'axios';
import { FORM_ERROR } from 'final-form';
import { useDispatch } from 'react-redux';

import { getMeThunk } from 'store/user/thunks';
import { setToken } from 'utils/accessToken';
import { setAuthToken } from 'utils/axios';

export function useNewPasswordForm({ token, method }: { token: string; method: Function }) {
  const dispatch = useDispatch();

  const handleSubmit = useCallback(
    (values: any) => {
      return method({ key: token, ...values })
        .then((data: { accessToken: string; refreshToken: string }) => {
          setAuthToken(data.accessToken);
          setToken(data);

          dispatch(getMeThunk());
        })
        .catch((err: AxiosError<{ fieldError?: string | string[] }>) => {
          if (err.response?.status === 422) {
            const fieldError = err.response?.data?.fieldError;
            if (Array.isArray(fieldError) && fieldError.length >= 2) {
              return { [fieldError[0]]: fieldError[1] };
            }
          }

          return {
            [FORM_ERROR]: 'The link for password resetting is expired. Please, resend email again',
          };
        });
    },
    [dispatch, method, token],
  );

  return { handleSubmit };
}
